import { ReactNode } from 'react'

import {
  emotionCache,
  getMantineThemeOverride,
  MantineProvider,
} from '@hhgtech/hhg-components/mantine'
import { MantineTheme } from '@mantine/core'

import { useRouterExtend } from 'hooks/useRouterExtend'
export const AppMantineProvider = ({
  children,
  customComponentTheme,
}: {
  children: ReactNode
  customComponentTheme?: string
}) => {
  const { locale } = useRouterExtend()
  const theme = getMantineThemeOverride(locale, 'hb')
  const customThemeFn = customComponentTheme && JSON.parse(customComponentTheme)
  const customComp: MantineTheme['components'] = {}
  Object.keys(customThemeFn || {}).map((component) => {
    customComp[component] = {
      ...theme.components?.[component],
      styles: {
        ...theme.components?.[component]?.styles,
        ...customThemeFn?.[component]?.styles,
      },
      defaultProps: {
        ...theme.components?.[component]?.defaultProps,
        ...customThemeFn?.[component]?.defaultProps,
      },
    }
  })

  return (
    <MantineProvider
      locale={locale}
      emotionCache={emotionCache}
      template="hb"
      theme={{
        ...theme,
        colors: {
          ...theme.colors,
          ...(customThemeFn?.colors || {}),
        },
        components: {
          ...theme.components,
          ...customComp,
        },
      }}
    >
      {children}
    </MantineProvider>
  )
}
